export default __webpack_public_path__ + "static/media/verify-card-icon.31d98d34.svg";